<template>
    <section>
        <v-dialog v-model="dialog" persistent max-width="750px">
            <v-card>
                <v-card-title class="headline grey lighten-2" primary-title>
                    <v-flex>Add Course Images</v-flex>
                    <v-btn icon @click="CloseDialog">
                        <v-icon color="text--secondary">close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-text>
                        <v-flex>
                            <v-radio-group v-model="Image_Type" row>
                                <v-radio label="Course Preview Image" value="Course_Preview_Image"></v-radio>
                                <v-radio label="Course Banner" value="Course_Banner"></v-radio>
                            </v-radio-group>
                        </v-flex>
                        <v-flex wrap style="padding: 10px;">
                            <v-flex>
                                <v-select v-model="SelectedCourseDetail" :items="GetCourseDetailList" label="Select Course Title"></v-select>
                            </v-flex>
                            <div style="width:400px;margin:auto;border: 1px solid #d3d3d37a;">
                                <v-flex>
                                    <img id="img" v-if="Image_File" :src="url" width="100%" />
                                </v-flex>
                                <v-flex style="text-align: center;">
                                    <v-btn color="primary" @click="$refs.inputUpload.click()">Upload Image    </v-btn>
                                    <input v-show="false" ref="inputUpload" type="file" @change="SelectedFile" >
                                </v-flex>
                            </div>
                        </v-flex>
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-flex style="text-align: right;">
                            <v-btn color="primary" v-if="Image_Type != 'Course_Preview_Image'" @click="SubmitBannerImage">Add Course Banner</v-btn>
                            <v-btn color="primary" v-else @click="SubmitPreviewImage">Add Course Preview Image</v-btn>
                        </v-flex>
                    </v-card-actions>
            </v-card>
        </v-dialog>
  </section>
</template>
<script>

export default {
    props: ['dialog'],
    data(){
        return {

            SelectedCourseDetail    : "",
            url                     : null,
            Image                   : null,
            Image_File              : false,
            Image_Type              : 'Course_Preview_Image'

        }
    },
    computed:{
        GetCourseDetailList(){
        
            return this.$store.getters.GetCourseDetailsList.map(x => x["Course_Title"])
        }
    },
    methods:{
        SelectedFile(e){
        
            this.Image = e.target.files[0]
            if(this.Image.type.split('/')[0] == "image"){
                
                this.Image_File = true
                this.url = URL.createObjectURL(this.Image);

            }else{
                
                this.Image_File = false
                this.url = URL.createObjectURL(this.Image);
            }

        },
        SubmitPreviewImage(){

            const fd = new FormData()
            fd.append('Course_image',this.Image,this.Image.name)
            fd.append('Course_Id',this.$store.getters.GetCourseDetailsList.find(x => x["Course_Title"] == this.SelectedCourseDetail)["_id"])
            let Preview_URL = `${this.$store.getters.GetProductionUrl}/coursepreviewvideo/addcoursepreviewimage`
            this.$http.post(Preview_URL,fd)
                        .then(response =>{

                            this.$store.commit('UpdateCourseDetails',response['data']['response'])
                            this.CloseDialog()   
                            this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Successfully Uploaded Image","Color":"green","Close": false });
                             
                        })
                        .catch(err =>{

                            this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Failed To Upload Image","Color":"red","Close": false });
                        })
        },
        SubmitBannerImage(){
            
            const fd = new FormData()
            fd.append('Course_Banner',this.Image,this.Image.name)
            fd.append('Course_Id',this.$store.getters.GetCourseDetailsList.find(x => x["Course_Title"] == this.SelectedCourseDetail)["_id"])
            let Preview_URL = `${this.$store.getters.GetProductionUrl}/coursepreviewvideo/addcoursebanner`
            this.$http.post(Preview_URL,fd)
                        .then(response =>{

                            this.$store.commit('UpdateCourseDetails',response['data']['response'])
                            this.CloseDialog()   
                            this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Successfully Uploaded Image","Color":"green","Close": false });
                             
                        })
                        .catch(err =>{

                            this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Failed To Upload Image","Color":"red","Close": false });
                        })

        },
        ClearForm(){

            this.url        = null
            this.Image      = null
            this.Image_File = false
            this.SelectedCourseDetail    = ""
            this.$refs.inputUpload.value = ""   
            this.Image_Type = 'Course_Preview_Image'
     
        },
        GetCourseListFromDB(){
            
            this.$http.post(`${this.$store.getters.GetProductionUrl}/course/getallcoursedetailslist`)
                        .then(response =>{

                            this.$store.commit('SetCourseDetailList',response["data"]["response"])
                        })
                        .catch(err =>{

                            this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Error While Fetching Data","Color":"red","Close": false });
                        })
        },
        CloseDialog(){

            this.ClearForm()
            this.$emit('close')

        }
    }
}
</script>
<style scoped>

</style>